export type KnownFuelTypes =
    | 'wood'
    | 'gas'
    | 'oil'
    | 'environmental_soil'
    | 'environmental_air'
    | 'environmental_solar'
    | 'electric_power'
    | 'erdgas'
    | 'fluessiggas'
    | 'heizoel_el'
    | 'strom'
    | 'nah_fernwaerme'
    | 'holzpellets'
    | 'holzhackschnitzel'
    | 'stueckholz'
    | 'waermepumpe'
    | 'solarthermie'
    | 'geothermie'
    | 'umweltwaerme'
    | 'hybrid_system'
    | 'biogas_biomethan'
    | 'steinkohle'
    | 'braunkohle'

export const FUEL_TYPE_LABELS: Record<KnownFuelTypes, string> = {
    wood: 'Holz',
    gas: 'Gas',
    oil: 'Öl',
    environmental_soil: 'Umweltw. (Boden)',
    environmental_air: 'Umweltw. (Außenluft)',
    environmental_solar: 'Umweltw. (Solarthermie)',
    electric_power: 'Strom',
    erdgas: 'Erdgas',
    fluessiggas: 'Flüssiggas',
    heizoel_el: 'Heizöl',
    strom: 'Strom',
    nah_fernwaerme: 'Nah-/Fernwärme',
    holzpellets: 'Holzpellets',
    holzhackschnitzel: 'Holzhackschnitzel',
    stueckholz: 'Stückholz',
    waermepumpe: 'Wärmepumpe',
    solarthermie: 'Solarthermie',
    geothermie: 'Geothermie',
    umweltwaerme: 'Umweltwärme',
    hybrid_system: 'Hybrid',
    biogas_biomethan: 'Biogas',
    steinkohle: 'Steinkohle',
    braunkohle: 'Braunkohle',
}

export function isKnownFuelType(value: string): value is KnownFuelTypes {
    return value in FUEL_TYPE_LABELS
}
